<template>
  <div class="project-player">
    <div id="loading" v-if="galleryItems.count === undefined">
      <h1 style="text-align:center; margin-top:4em;">
        Cargando proyectos
      </h1>
      <b-loading :active="true" :is-full-page="true"></b-loading>
    </div>
    <div v-else>
      <h1 class="is-size-4"> Elige uno de los proyectos para reproducir en la pantalla.</h1>
      <p class="is-size-6"> El número de proyectos que puedes elegir cada día está limitado a 10. Si tienes alguna duda escribe a: programalaplaza@gmail.com</p>
      <ul class = "project-list card">
        <li v-for = "p in galleryItems.results" :class = "{ 'playing': p.id === currentProject.id }" v-on:click = "openAndPlay(p)" :key = "p.id">
          <img class = "small-cover" :src = "p.cover" />
          <span>{{p.name}}</span>
        </li>
      </ul>
    </div>

  </div>

</template>

<script>
import EditorSimple from '../Editor/EditorSimple'
import Previewer from '../Previewer/Previewer'
import GalleryFilter from '../Gallery/GalleryFilter'
import ApiMlpTrackingCamera from './ApiMlpTrackingCamera'
import EditorScreenshotSaver from '../Editor/EditorScreenshotSaver'
import axios from 'axios'

export default {
  name: 'Mando',
  components: {
    EditorSimple,
    Previewer,
    GalleryFilter,
    ApiMlpTrackingCamera,
    EditorScreenshotSaver
  },
  props: {
    callid: {
      type: String,
      default: ''
    },
    tagsid: {
      type: String,
      default: ''
    },
    playlistid: {
      type: String,
      default: ''
    },
    projectid: {
      type: String,
      default: ''
    },
    classroomid: {
      type: String,
      default: ''
    },
    projecttimeinput: {
      type: String,
      default: '-1'
    }
  },
  watch: {
  },
  data () {
    return {
      searchParams: {
        page: 1,
        limit: 1000,
        call: '',
        tags: [],
        is_example: false,
        is_public: true,
        is_finished: true,
        codeAnalysis: {}
      },
      projectTime: 30,
      playlistSelected: 1,
      isPlaying: false,
      playlistHead: 0,
      currentProject: { id: -1 },
      userProjects: [],
      userInfo: {},
      isAdminShown: true,
      isScreenshotShown: false
    }
  },
  computed: {
    getAdminUrl () {
      // return 'http://127.0.0.1:8000/admin/'
      return 'http://programalaplaza.medialab-prado.es/admin/'
    },
    project () {
      return this.$store.state.project
    },
    galleryItems () {
      return this.$store.state.gallery.fetched
    },
    tags: function () {
      return this.$store.state.gallery.tags
    }
  },
  methods: {
    // open a single project, no timeouts
    openAndPlay: function (p) {
      axios.get('http://192.168.1.171:2526/playsketch?id=' + p.id)
        .then(response => this.$dialog.alert('Ok reproduciremos tu sketch en momento... <br/> <small> (si no te has pasado de 10 reproducciones)</small>'))
        .catch(err => {
          this.$dialog.alert(err + '<br/> Parece que tenemos un error con esto... prueba más tarde')
        })
    }

  },
  mounted () {
    // console.log(parseInt(this.projecttimeinput))
    if (this.projecttimeinput !== '-1' && isNaN(parseInt(this.projecttimeinput)) === false) {
      this.projectTime = parseInt(this.projecttimeinput)
      // console.log('project time')
    }

    if (this.classroomid !== '') {
      this.searchParams.classroom = this.classroomid
    }

    if (this.callid !== '') {
      this.searchParams.call = parseInt(this.callid)
    } else {
      this.searchParams.call = 15
    }

    if (this.tagsid !== '') {
      this.searchParams.tags = []
      this.tagsid.split(',').forEach(t => {
        if (!isNaN(parseInt(t))) {
          this.searchParams.tags.push(parseInt(t))
        }
      })
    } else {
      this.searchParams.tags = [18, 19, 20, 21]
    }

    let query = {
      params: this.searchParams
    }

    this.$store.dispatch('fetchProjectList', query)
  },
  destroyed () {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.project-player {
  background: #ccc;
  height: 100vh;
}

#project-player-grid {
  display: grid;
  grid-template: "play info info" 70px
                 "play editor editor" 200px
                 "list editor editor" auto;
  grid-template-columns: 0.75fr 1.25fr;
  grid-gap: 20px;
  padding: 20px;
  // margin: 20px;
  height: 100vh;

  &.showAdmin {
    grid-template: "play info info" 50px
                   "play info info" 200px
                   "list info info" 200px
                   "list editor editor" auto;
    grid-template-columns: 0.75fr 1.25fr;
  }
}

.previewing {
  padding: 20px 0px 20px 20px;
  margin-top: 220px;

  #previewer{
    position: absolute;
    top: 40px;
    left: 40px;
  }

}

.editor2 {
  grid-area: editor;
  border-radius: 10px;
  overflow: hidden;
  height: auto !important;
}

.controls {
  grid-area: play;
  display: flex;
  justify-content: space-between;

  select {
    flex: 2;
  }

  input {
    margin: 7px;
    padding: 10px;
    color: black;
  }

  input#time {
    max-width: 50px;
    border-radius: 100px !important;
    width: 50px;
    height: 50px;
    text-align: center;
    border: 3px solid #2fe67c !important;
    background: transparent !important;
  }

  .play {
    margin-right: 20px;

    #playstopbutton {
      padding: 0 5px;
    }
  }

  .sketch-input-selectors {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
}

#project-player-admin {
  grid-area: info;
  padding: 10px;
  overflow: auto;
  background: @adminColor;
  color: white;

  .admin-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .admin {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    margin-top: 20px;

    a {
      color: white;
      text-decoration: underline;
    }

    .admin-info {
      .is-not-finished {
        color: red;
      }

    }

    .admin-edit {

    }

    .admin-label {
      color: white;
      margin-bottom: 5px;
      font-weight: 800;
    }

    ul {
      margin-bottom: 20px;
    }

    .project-type {
      background: #fff5;
      border-radius: 2px;
      padding: 5px 8px;

      &.project-type-processingjs {
        background: red;
      }
    }
  }

  .tags {
    button {
      color: #000a;
      background: #0003;
      padding: 5px 8px;
      border-radius: 2px;
      // box-shadow: 1px 1px 1px 0px #0002;
      display: inline-block;
      margin: 5px 5px 5px 0px;

      &.selected {
        color: white;
        background: #222;
      }
    }
  }
}

.small-cover {
  border: 1px solid black;
  width: 30px;
  height: 30px;
  object-fit: cover;
}

li {
  display: flex;
  display: flex;
  align-items: center;

  * {
    margin-right: 5px;
  }
}

.project-list {
  grid-area: list;
  overflow:auto;

  li {
    padding: 5px;
    cursor: pointer;
  }

  li:hover {
    background: lighten(@accentColor, 20%);
  }
  .playing {
    background: @accentColor;
  }
}

.debug2 {
  position: absolute;
  z-index: 12;

  p {
    background: white;
    padding: 12px;
    margin: 12px;
  }
}
.abs {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 500px;
  height: 500px !important;
}

.card {
  background: white;
  border-radius: 2px;
  box-shadow: 0 0 3px 0 #0005;

  &.card-dark {
    background: @backgroundColor;
  }
}
#loading{
  width:100vw;
  height:100vh;
}

</style>



// WEBPACK FOOTER //
// src/components/ProjectPlayer/Mando.vue